import { defineMessages } from 'react-intl';

export default defineMessages({
    actionRequired: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICValidationMessageModal.WMICValidationMessageModal.Action Required',
        defaultMessage: 'Action Required',
    },
});
